// import * as ZXing from '@/lib/zxing/zxing.js';
// import Module from '@/lib/zxing/zxing.js';

import { validationMixin } from 'vuelidate';
import { required, requiredIf, maxLength} from 'vuelidate/lib/validators';


export default {
    mixins: [validationMixin],

    validations: {
        barcode    : {
            // required,
            required : requiredIf(function (model) {
                console.info('barcode required', this.required);
                return this.required;
            }),
            maxLength : maxLength(50)
        },
    },
    components: {
    },
    props: {
        label       :  {
            type    : String,
            default : "Barcode"
        },
        hint       :  {
            type    : String,
            default : ""
        },
        required       :  {
            type    : Boolean,
            default : false
        },
        disabled       :  {
            type    : Boolean,
            default : false
        },
        value       :  {
            type    : String,
            default : null
        },
        persistentHint  :  {
            type    : Boolean,
            default : false
        },
    },
    data() {
        return {
            barcode         : null,
            dialog          : false,
            toggle_zoom     : null,
            torchOnIcon     : 'mdi-flash',
            torchOffIcon    : 'mdi-flash-off',
            torchActiveIcon : 'mdi-flash',
            //
            // _btnCameraSettings     = this._modalEl.find('.icl-barcode-scanner-btn-settings');
            // _resultInput           = this._modalEl.find('.icl-barcode-scanner-input-result');
            // _zoomButtons           = this._modalEl.find('.btn-group-vertical > .btn');
            // _btnZoomGroup          = this._modalEl.find('.icl-barcode-scanner-zoom-group');
            // _btnZoom01             = this._modalEl.find('.icl-barcode-scanner-btn-zoom-01');
            // _btnZoom02             = this._modalEl.find('.icl-barcode-scanner-btn-zoom-02');
            // _btnZoom04             = this._modalEl.find('.icl-barcode-scanner-btn-zoom-04');
            // _btnZoom08             = this._modalEl.find('.icl-barcode-scanner-btn-zoom-08');
            // _btnTorch              = this._modalEl.find('.icl-barcode-scanner-btn-torch');
            // _containerFirst        = this._modalEl.find('.icl-barcode-scanner-container-first');
            // _containerSecond       = this._modalEl.find('.icl-barcode-scanner-container-second');
            // _containerCameraSource = this._modalEl.find('.icl-barcode-scanner-container-camera-source');
            // _selectCameraSource    = this._modalEl.find('.icl-barcode-scanner-select-camera-source');
            // _canvasOverlay         = this._modalEl.find('.icl-barcode-scanner-canvas-overlay')[0];
            // _video                 = this._modalEl.find('video');
            // _videoContent          = this._modalEl.find('.icl-barcode-scanner-video-content');
            // _errorsContainer       = this._modalEl.find('.icl-barcode-scanner-errors-container');
            // _btnSave               = this._modalEl.find('.cls-button-save');
            // _btnCancel             = this._modalEl.find('.cls-button-cancel');
            //
            // _canvasH               = document.createElement('canvas');
            // _canvasV               = document.createElement('canvas');
            //
            // _videoEl = this._video[0];
            //
            // _track = null;

            //states
            // _isCameraSelected = false;
            // _torchEnabled     = false;

            //colors
            // _colorBlue  = '#337ab7';
            // _colorGreen = '#5cb85c';
            // _colorRed   = '#a94442';

            //buttons
            // this._btnCancel.on('click', $.proxy(this._onClickCancel, this));
            // this._btnSave.on('click', $.proxy(this._onClickSaveButton, this));
            // this._btnCameraSettings.on('click', $.proxy(this._onClickSettingsButton, this));
            // this._zoomButtons.on('click', $.proxy(this._onZoomClick, this));
            // this._btnTorch.on('click', $.proxy(this._onTorchClick, this));
            //
            // //video metadata
            // this._video.on('loadedmetadata', $.proxy(this._onLoadedMetadata, this));
            // this._video.on('play',           $.proxy(this._onPlay, this));
            //
            // this._selectCameraSource.on('change', $.proxy(this._onSelectCameraSourceChange, this));


        };
    },
    computed: {

    },
    methods : {
        onBarcodeIconClick() {
            // return alert('--- Barcode Scanner will be available soon ---');
            // console.info('thiiiiiiis barcode', this, ZXing);
            // console.info('thiiiiiiis barcode', this, Module);
            this.dialog = !this.dialog;
            // this._initAll(ZXing);
            // this._loadAll();
        },
        getValue() {
            return this.barcode;
        },
        setValue(value) {
            this.barcode = value;
            return;
        },
        resetValue() {
            this.barcode = null;
            return;
        },
        validate() {
            console.info('barcode validate', this.$v);
            this.$v.barcode.$touch();
            if(!this.$v.barcode.$dirty) {
                return false;
            } else {
                this.$v.barcode.$touch();
                if (!this.$v.barcode.$anyError) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        onTorchBtnClick() {
            if (this.torchActiveIcon == this.torchOnIcon) {
                this.torchActiveIcon = this.torchOffIcon;
            } else {
                this.torchActiveIcon = this.torchOnIcon;
            }
        },
        //----------------------------- BARCODE -------------------------------
        show: function(inputId) {
            this.setLoading(true);
            this._inputId = inputId;
            this._resetTemplateValues();
        },
        _resetTemplateValues: function() {
            this._zoomButtons.removeClass('btn-default');
            this._zoomButtons.addClass('btn-primary');
            this._btnZoom01.removeClass('btn-primary');
            this._btnZoom01.addClass('btn-default');
            this._zoomButtons.prop("disabled",false);
            this._btnZoom01.prop('disabled', true);
            this._btnTorch.removeClass('icl-icons-16-no-flash-1');
            this._btnTorch.addClass('icl-icons-16-flash-1');
            this._btnCameraSettings.addClass("hidden");
            this._resultInput.addClass('hidden');
        },
        _loadAll: function() {
            var me = this;

            require([
                '@/lib/zxing/zxing.js'
            ], function(ZXingLoader) {
                console.info('ZXingLoader', ZXingLoader);
                me._initAll(ZXingLoader);
            });
        },
        _initAll: function(ZXingLoader) {
            var me = this;
            ZXingLoader
            .then(function(ZXing) {
                me._ZXing = ZXing;

                me._resultValidUntil = (new Date()).getTime();
                me._resultRaw        = null;

                var fn = function(ptr, len, resultIndex, resultCount) {
                    var result = new Uint8Array(ZXing.HEAPU8.buffer, ptr, len);
                    var content = String.fromCharCode.apply(null, result);
                    if ((new Date()).getTime() <= me._resultValidUntil) {
                        if (content === me._resultRaw) {
                            return;
                        }
                    }
                    me._resultInput.val(content);
                    me._resultRaw = content;
                    me._resultValidUntil = (new Date()).getTime() + 1000;
                    me._btnSave.attr('disabled', false);
                    me._beep();
                    me._drawCanvas(me._colorGreen);
                };

                me._decodePointer = ZXing.addFunction(fn);
                // <debug>
                console.log('----- WAS.ch BARCODE SCANNER initialized');
                // </debug>
                return Promise.resolve(ZXing);
            })
            .catch(function(e) {
                console.error('Unable to load library.', e);
                return Promise.reject(false);
            })
            .then(function(ZXing) {
                return navigator.mediaDevices.enumerateDevices();
            })
            .catch(function(e) {
                if (e === false) {
                    return Promise.reject(false);
                }
                console.error('Unable to enumerate devices.', e);
                return Promise.reject(false);
            })
            .then(function(deviceInfos){
                var videoInputDevices = _.filter(deviceInfos, function(d) {
                    return (d.kind === 'videoinput');
                });

                if (videoInputDevices.length < 1) {
                    return Promise.reject(me.errorCodes.ERROR_CODE_NO_DEVICES_FOUND);
                }

                var deviceId = localStorage.getItem('icl-barcode-scanner-device-id');
                var valid    = false;

                for (var i in videoInputDevices) {
                    if (videoInputDevices[i].deviceId === deviceId) {
                        valid = true;
                        break;
                    }
                }

                me._fillDeviceList(videoInputDevices, deviceId);

                if (valid === true) {
                    me._btnCameraSettings.removeClass("hidden");
                    return me._startDevice(deviceId)
                        .then(function() {
                            me.setLoading(false);
                        });
                } else {
                    return me._selectDevice();
                }

            })
            .catch(function(e) {
                console.error('Error occured.', e);
                var text = me.errorTexts[e] || '21533:Ein Fehler ist aufgetreten. Bitte versuchen Sie nochmals.';
                me._errorsContainer.html('<span data-trt="' + text + '"></span>');
                Translate.translateEl(me._modalEl);
                me._videoContent.addClass('hidden');
                me._containerSecond.addClass('hidden');
                me._errorsContainer.removeClass('hidden');
            })
            .then(function() {
                me.setLoading(false);
            });
        },
        _fillDeviceList: function(devices, deviceId) {
            var el = this._selectCameraSource;
            el.empty();

            var optDefault   = document.createElement('option');
            optDefault.text  = '--- 21532:Kamera auswählen ---';
            optDefault.value = '';
            el.append(optDefault);

            var counter = 1;

            devices.forEach(function(element) {
                var text = element.label;
                if (!text) {
                    // The label name is missing, when the user has not
                    // accepted the access, yet.
                    text = 'Camera ' + counter;
                    counter++;
                }
                var opt   = document.createElement('option');
                opt.text  = text;
                opt.value = element.deviceId;
                if (element.deviceId === deviceId) {
                    opt.selected = true;
                }
                el.append(opt);
            });
        },
        _selectDevice: function() {
            var me = this;

            return new Promise(function(resolve, reject) {
                var el = me._containerCameraSource;
                el.css('display', 'block');
                me._drawMessageCanvas();
                me._containerFirst.removeClass("hidden");
                me._isCameraSelected = false;
                resolve(true);
            });
        },
        _startDevice: function(deviceId) {
            var me = this;

            var done = new Promise(function(resolve, reject) {
                me._startDoneResolve = resolve;
                me._startDoneReject  = reject;
            });

            return new Promise(function(resolve, reject) {
                var videoContraints = { video : { deviceId: deviceId }};
                navigator.mediaDevices.getUserMedia(videoContraints)
                    .then(function(stream) {
                        me._video.removeClass('hidden');
                        me._videoEl.srcObject = stream;
                        me._track             = stream.getVideoTracks()[0];
                        me._isCameraSelected  = true;
                        me._resultInput.removeClass('hidden');
                        return done;
                    })
                    .then(function() {
                        me._scanBarcode();
                        resolve(true);
                    })
                    .catch(function(e) {
                        reject(e);
                    });
            });
        },
        _stopDevice: function() {
            this._isCameraSelected = false;
            if (this._track) {
                this._track.stop();
                this._track = null;
            }
            this._videoEl.pause();
            this._video.addClass('hidden');
            this._resetTemplateValues();
        },
        _onLoadedMetadata: function() {
            var me = this;

            var w = this._videoEl.videoWidth;
            var h = this._videoEl.videoHeight;

            this._canvasH.width  = w;
            this._canvasH.height = h;
            this._canvasV.width  = w;
            this._canvasV.height = h;

            this._canvasHCtx = this._canvasH.getContext('2d');
            this._canvasVCtx = this._canvasV.getContext('2d');

            this._canvasHCtx.width  = this._canvasH.width;
            this._canvasHCtx.height = this._canvasH.height;
            this._canvasVCtx.width  = this._canvasV.width;
            this._canvasVCtx.height = this._canvasV.height;

            this._startCamera();
        },
        _onCapabilitiesReady: function(capabilities) {
            var me = this;

            return new Promise(function(resolve, reject) {
                var r = {
                    torch : false,
                    zoom  : false
                };

                if (capabilities.torch) {
                    r.torch = true;
                }

                if (capabilities.zoom) {
                    r.zoom = true;
                    var levels = [
                        [(capabilities.zoom.min * 1), me._btnZoom01],
                        [(capabilities.zoom.min * 2), me._btnZoom02],
                        [(capabilities.zoom.min * 4), me._btnZoom04],
                        [(capabilities.zoom.min * 8), me._btnZoom08]
                    ];

                    levels.forEach(function(value, idx) {
                        var zoomValue = value[0];
                        var button    = value[1];
                        if (capabilities.zoom.max >= zoomValue) {
                            button.attr('data-value', zoomValue);
                            button.removeClass('hidden');
                            button.removeClass('icl-last-visible-group-button');
                        } else {
                            var lastVisibleButton = levels[idx - 1][1];
                            lastVisibleButton.addClass('icl-last-visible-group-button');
                        }
                    });
                }

                resolve(r);
            });
        },
        _onTorchClick: function() {
            var me = this;

            if (this._torchCommandRunning) {
                return;
            }
            this._torchCommandRunning = true;
            var el = this._btnTorch;
            el.prop("disabled", true);
            var iconTorch   = el.find('div');
            var iconSpinner = el.find('span');
            iconTorch.addClass('hidden');
            iconSpinner.removeClass('hidden');
            try {
                var contraints = this._track.getConstraints();
                var settings = this._track.getSettings();
                if (this._torchEnabled) {
                    this._torchEnabled = false;
                } else {
                    this._torchEnabled = true;
                }
            } catch (e) {
                this._torchCommandRunning = false;
                return;
            }
            this._track.applyConstraints({
                advanced: [{torch: this._torchEnabled}]
            })
            .catch(function(e) {
                me._torchEnabled = !me._torchEnabled;
                console.error(e);
            })
            .then(function() {
                me._torchCommandRunning = false;
                if (me._torchEnabled) {
                    iconTorch.addClass('icl-icons-16-no-flash-1');
                    iconTorch.removeClass('icl-icons-16-flash-1');
                } else {
                    iconTorch.addClass('icl-icons-16-flash-1');
                    iconTorch.removeClass('icl-icons-16-no-flash-1');
                }
                iconSpinner.addClass('hidden');
                iconTorch.removeClass('hidden');
                el.prop("disabled",false);
            });

        },
        _onZoomClick: function() {
            var me = this;

            if (this._zoomCommandRunning) {
                return;
            }
            this._zoomCommandRunning = true;
            var el = $(event.currentTarget);
            var btnTxt      = el.find('span.cls-btn-text');
            var btnTxtValue = btnTxt.text();
            btnTxt.empty();
            var iconEl = el.find('span.cls-icon-torch-spinner');
            iconEl.removeClass('hidden');
            this._zoomButtons.prop("disabled",true);
            var zoomValue = el.data('value');
            this._track.applyConstraints(
                {advanced: [ {zoom: zoomValue}]
            })
            .catch(function(e) {
                console.error(e);
                me._zoomCommandRunning = false;
                iconEl.addClass('hidden');
                btnTxt.text(btnTxtValue);
            })
            .then(function() {
                me._zoomCommandRunning = false;
                iconEl.addClass('hidden');
                btnTxt.text(btnTxtValue);
                me._zoomButtons.removeClass('btn-default');
                me._zoomButtons.addClass('btn-primary');
                el.addClass('btn-default');
                el.removeClass('btn-primary');
                me._zoomButtons.prop("disabled",false);
                el.prop("disabled",true);
            });
        },
        _onClickCancel: function() {
            this.setLoading(true);
            this._stopDevice();
            this.hide();
            this.setLoading(false);
        },
        _onClickSaveButton: function() {
            this.setLoading(true);
            this.trigger('saveBarCodeScannerValue', this._resultInput.val());
            var inputField = $('#' + this._inputId);
            inputField.val(this._resultInput.val());
            this._stopDevice();
            this.hide();
            this.setLoading(false);
        },
        _onClickSettingsButton: function() {
            this.setLoading(true);
            this._btnCameraSettings.addClass('hidden');
            this._containerFirst.removeClass('hidden');
            this.setLoading(false);
        },
        _scanBarcode: function() {
            if (this._videoEl.paused || this._videoEl.ended) {
                return;
            }

            this._drawCanvas(this._colorBlue);

            var w   = this._videoEl.videoWidth;
            var h   = this._videoEl.videoHeight;
            var ctx = this._canvasHCtx;

            ctx.clearRect(0, 0, w, h);
            ctx.drawImage(this._videoEl, 0, 0, w, h);

            var ok = this._decode(ctx, w, h);
            if (ok === false) {
                var frame = ctx.getImageData(0, 0, w, h);

                var ctx1 = this._canvasVCtx;
                ctx1.clearRect(0, 0, h, w);

                ctx1.save();
                var rotation = -90 * Math.PI / 180;
                ctx1.rotate(rotation);
                ctx1.translate(-ctx1.height, 0);
                ctx1.drawImage(this._canvasH, 0, 0, w, h, 0, 0, ctx1.height, ctx1.width);
                ctx1.restore();

                ok = this._decode(ctx1, w, h);
            }

            var timeout = 30;
            if (ok) {
                // Keeps the green cross a bit longer.
                timeout = 300;
            }

            setTimeout($.proxy(this._scanBarcode, this), timeout);
        },
        _decode: function(ctx, w, h) {
            var ZXing = this._ZXing;

            var frame     = ctx.getImageData(0, 0, w, h);
            var imageData = frame.data;

            var image = ZXing._resize(w, h);
            for (var i = 0, j = 0; i < imageData.length; i += 4, j++) {
                ZXing.HEAPU8[image + j] = imageData[i];
            }
            var err = ZXing._decode_any(this._decodePointer);

            return (err === 0);
        },
        _onPlay: function() {
            var me = this;

            setTimeout(function() {
                me._onCapabilitiesReady(me._track.getCapabilities())
                    .then(function(capabilities) {
                        if (capabilities.torch === true) {
                            me._btnTorch.removeClass("hidden");
                        } else {
                            me._btnTorch.addClass("hidden");
                        }
                        if (capabilities.zoom === true) {
                            me._btnZoomGroup.removeClass("hidden");
                        } else {
                            me._btnZoomGroup.addClass("hidden");
                        }
                        me._startDoneResolve(true);
                    })
                    .catch(function(e) {
                        me._startDoneReject(e);
                    });
            }, 500);
        },
        _startCamera : function() {
            this._clear();
            this._resultValidUntil = (new Date()).getTime();
            this._resultRaw = null;
            this._video.show();
            this._videoEl.play();
            this._setZoomButtonsOrientation();
        },
        _beep : function() {
            var snd = new Audio("data:audio/wav;base64,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");
                snd.play();
        },
        _drawConfimationCanvas : function(success) {
            var me = this;
            if (success) {
                this._drawCanvas(this._colorGreen);
            } else {
                this._drawCanvas(this._colorRed);
            }
            window.setTimeout(function(){
                me._drawCanvas(me._colorBlue);
            }, 300);
        },
        _drawCanvas : function(color) {
            var videoTagWidth  = this._videoEl.offsetWidth;
            var videoTagHeight = this._videoEl.offsetHeight;

            var canvas = this._canvasOverlay;
            canvas.width  = videoTagWidth;
            canvas.height = videoTagHeight;

            var ctx  = canvas.getContext("2d");
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = color;
            ctx.moveTo((videoTagWidth / 2), ((videoTagHeight - 100) / 2));
            ctx.lineTo((videoTagWidth / 2), ((videoTagHeight - 100 ) / 2) + 100);
            ctx.stroke();
            ctx.moveTo(((videoTagWidth - 100) / 2), (videoTagHeight  / 2));
            ctx.lineTo((((videoTagWidth - 100) / 2) + 100),  (videoTagHeight / 2));
            ctx.stroke();

            return ctx;
        },
        _drawMessageCanvas : function() {
            this._clearMessageCanvas();
            var videoTagWidth  = this._videoEl.offsetWidth;
            var videoTagHeight = this._videoEl.offsetHeight;

            var canvas = this._canvasOverlay;
            canvas.width  = videoTagWidth;
            canvas.height = videoTagHeight;

            var ctx  = canvas.getContext("2d");
            ctx.font="12px Verdana";
            ctx.fillStyle = "black";
            ctx.textAlign = "center";
            ctx.fillText("21531:Bitte wählen Sie oben eine Kamera aus", canvas.width/2, canvas.height/2);
        },
        _clearCanvas : function() {
            var canvas = this._canvasOverlay;
            var ctx    = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        },
        _clearMessageCanvas : function() {
            var canvas = this._canvasOverlay;
            var ctx    = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        },
        _onSelectCameraSourceChange: function(e) {
            var me = this;

            this.setLoading(true);

            var deviceId = e.currentTarget.value;

            this._stopDevice();
            this._clearCanvas();
            this._clearMessageCanvas();

            if (deviceId) {
                localStorage.setItem('icl-barcode-scanner-device-id', deviceId);
                this._startDevice(deviceId)
                    .then(function() {
                        me.setLoading(false);
                    })
                    .catch(function(e) {
                        me.setLoading(false);
                        // TODO : display errors
                        console.error(e);
                    });
            } else {
                localStorage.removeItem('icl-barcode-scanner-device-id');
                this._btnTorch.addClass('hidden');
                this._btnZoomGroup.addClass('hidden');
                this._drawMessageCanvas();
                this.setLoading(false);
            }
        },
        _onResizeScreen : function() {
            var me = this;
            this.setLoading(true);
            if(this._isCameraSelected) {
                this._clearCanvas();
                this._clearMessageCanvas();
                this._drawCanvas(me._colorBlue);
                this._setZoomButtonsOrientation();
            } else {
                this._clearCanvas();
                this._clearMessageCanvas();
                this._drawMessageCanvas();
            }
            this.setLoading(false);
        },
        _setZoomButtonsOrientation : function() {
            var me = this;
            var el = this._btnZoomGroup;
            var videoTagWidth  = this._videoEl.offsetWidth;
            var videoTagHeight = this._videoEl.offsetHeight;
            if (videoTagWidth > videoTagHeight) {
                el.css({display: "inline-flex"});
                el.removeClass('btn-group-vertical');
                el.addClass('btn-group');
            } else {
                el.css({display: "inline-block"});
                el.addClass('btn-group-vertical');
                el.removeClass('btn-group');
            }
        },
        _clear : function() {
            this._resultInput.val('');
        }
    },
    created() {
        console.info('barcode scanner this', this);
    },
    computed: {
        barcodeErrors () {
            const errors = [];
            if (!this.$v.barcode.$dirty) {
                return errors;
            }
            if (!this.$v.barcode.maxLength) {
                errors.push('barcode must be at most 50 characters long');
            }
            if (!this.$v.barcode.required) {
                errors.push('barcode is required.');
            }
            return errors;
        },
    },

};
